/**
 *
 * @param endDate - "YYYY-MM-DD" - ("2026-10-30")
 * @param count - number of days to generate
 * @returns array of dates in "YYYY-MM-DD" format, starting from startDate and going backwards
 * @example generateDateRangeReverse("2026-10-30", 3) => ["2026-10-30", "2026-10-29", "2026-10-28"]
 */
export function generateDateRangeReverse(endDate: string, count: number): string[] {
  const dates: string[] = [];
  const date = new Date(endDate);

  for (let i = 0; i < count; i++) {
    const formattedDate = date.toISOString().split('T')[0];
    dates.push(formattedDate);

    date.setDate(date.getDate() - 1);
  }

  return dates;
}
